import { ApplicationState } from '@app/store'
import {
  IGlobalCompanyContactsState,
  IGlobalConfigurationState,
  IGlobalDevelopmentProjectClients,
  selectCompanyContacts,
  selectConfiguration,
  selectDevelopmentSiteMetadata,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import AssignmentsListPage from '../components/DevelopmentProjectsPage'
import {
  actionCreators,
  IDevelopmentProjectsListState,
  selectCity,
  selectClient,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectOrderBy,
  selectSortOrder,
  selectStatus,
  selectTotalItems,
} from '../modules/developmentProjectsList'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IDevelopmentProjectsListState &
      IGlobalDevelopmentProjectClients &
      IGlobalCompanyContactsState &
      IGlobalConfigurationState
  >({
    city: selectCity(),
    client: selectClient(),
    companyContacts: selectCompanyContacts(),
    configuration: selectConfiguration(),
    developmentSiteMetadata: selectDevelopmentSiteMetadata(),
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    orderBy: selectOrderBy(),
    sortOrder: selectSortOrder(),
    status: selectStatus(),
    totalItems: selectTotalItems(),
  }),
  actionCreators,
)(AssignmentsListPage)
